<template>
    <v-row>
        <v-col
            v-if="$vuetify.breakpoint.smAndDown && sideCardsAvailable"
            cols="10"
            offset="1"
        >
            <card
                v-for="card in news"
                :key="card.id"
                :elements="card.content"
                class="bg-alpha-white"
            />
        </v-col>
        <v-col 
            v-for="card in content" 
            :key="card.id"
            cols="12"
            offset="0"
            :md="sideCardsAvailable ? '8' : '10'"  
            :offset-md="sideCardsAvailable ? '0' : '1'" 
            :xl="sideCardsAvailable ? '7' : '8'" 
            :offset-xl="sideCardsAvailable ? '1' : '2'"
        >
            <card
                :elements="card.content"
                main
                class="pt-4 bg-alpha-white"
            />
        </v-col>
        <v-col
            v-if="$vuetify.breakpoint.smAndDown && sideCardsAvailable"
            cols="12"
        >
            <PromptCard
                v-for="(prompt, index) in prompts"
                :key="index" 
                class="mb-4" 
                :title="prompt.title" 
                :subtitle="prompt.subtitle"
                :icon="prompt.icon"
                :target="prompt.target"
                :route="prompt.route"
                :color="prompt.color"
            />
        </v-col>
        <v-col
            v-if="$vuetify.breakpoint.smAndDown && sideCardsAvailable"
            cols="12"
        >
            <card
                v-for="card in honors"
                :key="card.id"
                :elements="card.content"
                class="pt-4 bg-alpha-white"
                main
            />
        </v-col>
        <v-col
            v-if="$vuetify.breakpoint.mdAndUp && sideCardsAvailable"
            cols="4"
            xl="3"
        >
            <card
                v-for="card in news"
                :key="card.id"
                :elements="card.content"
            />
            <PromptCard
                v-for="(prompt, index) in prompts"
                :key="index" 
                class="mb-4" 
                :title="prompt.title" 
                :subtitle="prompt.subtitle"
                :icon="prompt.icon"
                :target="prompt.target"
                :route="prompt.route"
                :color="prompt.color"
            />
            <card
                v-for="card in honors"
                :key="card.id"
                :elements="card.content"
                class="pt-4 bg-alpha-white"
                main
            />
        </v-col>
    </v-row>
</template>

<script>
import Card from "@/components/Card/Card.vue";
import PromptCard from "@/components/Card/PromptCard.vue";

export default {
    name: "Home",
    components: {
        Card,
        PromptCard
    },
    data: () => ({
        content: [
            {
                id: 1,
                content: [
                    /*
                    {
                        type: "image",
                        src: "logos/az-2023-logo",
                        fileTypes: [
                            "png"
                        ],
                        maxWidth: "1000px",
                        autoSizing: false,
                        aspectRatio: 2,
                        contain: true,
                        customClassName: "mx-auto"
                    },
                    */
                    {
                        type: "video_embedded",
                        url: "https://www.youtube-nocookie.com/embed/ZU6wF17ubYc?si=In29KNf6vvcAL9QA",
                        aspectRatio: 0.5625
                    },
                    {
                        type: "spacer",
                        height: 1
                    },/*
                    {
                        type: "text",
                        text: `Jetzt anmelden für Aktion Zukunft 2023!`,
                        fontWeight: "bold"
                    },
                    {
                        type: "text",
                        text: `Aktion Zukunft ist ein Projekt von <a href="https://www.one-future.de" target="_blank">One Future e.V.</a>. 
                        Das vollfinanzierte Seminar zwischen <b>27. und 29. Oktober in Berlin</b> 
                        dient der Förderung engagierter junger Erwachsener, die Integrationsprojekte für und mit Menschen 
                        mit Fluchterfahrung aufbauen möchten. Während des Programms lernen Teilnehmende bei Workshops zum 
                        Projekt- und Finanzmanagements sowie zur Gründung gemeinnütziger juristischer Personen, wie sie eine 
                        soziale Initiative aufbauen können. Durch Impulse von Personen, die bereits erfolgreich mit Geflüchteten 
                        arbeiten, erhalten sie zudem Inspiration zu möglichen Projektansätzen und erkennen Bedarfe der Zielgruppe. 
                        Ehemalige des Seminars können für die Umsetzung ihrer Projekte Fördergelder erhalten.`
                    },
                    {
                        type: "text",
                        text: `Das Seminar wurde in den Jahren 2016 und 2018 durchgeführt, und erhielt Auszeichnungen der 
                        <a href="https://www.studienstiftung.de/auszeichnungen/engagementpreise/spendenaufruf-der-studienstiftung-fuer-den-engagementpreistraeger-sowie-die-finalistinnen-und-finalisten2019/finalist-des-engagementpresises-2019-joshua-kriesmann-aktion-zukunft/" target="_blank">Studienstiftung des deutschen Volkes e.V.</a> 
                        und <a href="https://www.engagementpreis.de/preistraeger-innen-2019" target="_blank">Friedrich-Ebert-Stiftung Ehemaligen e.V.`
                    },
                    {
                        type: "actions",
                        buttons: [
                            {
                                text: "Mehr erfahren",
                                type: "internal",
                                route: "/seminar"
                            },
                            {
                                text: "Anmeldung bis 15.08.",
                                type: "external",
                                url: "https://forms.gle/PVyEK4xQSEEeTuin6"
                            }
                        ]
                    }
                    */
                ]
            }
        ],
        news: [
        ],
        prompts: [
            {
                title: "Unterstützen",
                subtitle: "Aktion Zukunft",
                icon: "mdi-arrow-right",
                color: "#006064",
                target: "https://www.betterplace.org/de/projects/64975-aktion-zukunft"
            }
        ],
        honors: [
            {
                id: "6",
                content: [
                    {
                        type: "text",
                        text: `Das Projekt wurde ausgezeichnet von:`
                    },
                    {
                        type: "spacer",
                        height: 2
                    },
                    {
                        type: "image",
                        src: "honors/sdv",
                        fileTypes: [
                            "png",
                            "webp"
                        ],
                        maxHeight: "150",
                        autoSizing: false,
                        aspectRatio: 1.365,
                        contain: true,
                        customClassName: "mx-auto"
                    },
                    {
                        type: "spacer",
                        height: 2
                    },
                    {
                        type: "image",
                        src: "honors/fes1",
                        fileTypes: [
                            "png",
                            "webp"
                        ],
                        maxHeight: "100",
                        autoSizing: false,
                        aspectRatio: 2,
                        contain: true,
                        customClassName: "mx-auto"
                    },
                    {
                        type: "spacer",
                        height: 2
                    },
                    {
                        type: "image",
                        src: "honors/fes2",
                        fileTypes: [
                            "png",
                            "webp"
                        ],
                        maxHeight: "150",
                        autoSizing: false,
                        aspectRatio: 2,
                        contain: true,
                        customClassName: "mx-auto"
                    }
                ]
            }
        ]
    }),
    computed: {
        sideCardsAvailable: function() {
            return this.news.length > 0 || this.prompts.length > 0;
        }
    }
};
</script>
